export interface Aria {
  galleryLabel: string;
  viewerLabel: string;
}

export const defaultAria: Aria = {
  galleryLabel: 'Image Gallery',
  viewerLabel: 'Displayed gallery images.',
};
